import { SWRConfiguration } from "swr";

import { QueryParams, useAPI } from "./useAPI";
import { useSubmit, UseSubmitOptions } from "./useSubmit";
import { paths } from "../generated-schemas/shared";
import {
  GetRequest,
  CombinedPaths,
  PostRequest,
  ExtractPostResponseData,
  ExtractPostRequestBody,
  FilterByFetchType,
  InferAPI,
  InferAPIOptions,
} from "../types";

type GetSchemas = CombinedPaths<FilterByFetchType<paths, GetRequest>>;
type PostSchemas = CombinedPaths<FilterByFetchType<paths, PostRequest>>;
type PostPaths = keyof PostSchemas;
type GetPaths = keyof GetSchemas;

export const useSharedAPI = <PATH extends GetPaths>(
  path: PATH | null,
  query?: QueryParams,
  options?: SWRConfiguration
) => {
  type Responses = GetSchemas[PATH]["get"]["responses"];
  type Data = Responses[200]["content"]["application/json"];
  return useAPI<Data>(path, query, options);
};

export type InferSharedAPI<
  PATH extends GetPaths,
  Options extends InferAPIOptions = "data",
> = InferAPI<typeof useSharedAPI<PATH>, Options>;

export const useSharedSubmit = <PATH extends PostPaths>(
  path: PATH,
  options?: UseSubmitOptions<ExtractPostResponseData<PostSchemas, PATH>>
) => {
  return useSubmit<
    ExtractPostResponseData<PostSchemas, PATH>,
    ExtractPostRequestBody<PostSchemas, PATH>
  >(path, options || {});
};
